<template>
  <table>
    <tr class="header-table">
      <th>زمان و تاریخ</th>
      <th>مقدار(تومان)</th>
      <th class="hide-768">بانک | شماره شبا</th>
      <th class="hide-768">شماره پیگیری</th>
      <th>وضعیت</th>
    </tr>

    <tr class="body" v-for="(item , index) in transactions" :key="index+1">
      <td><span>{{ $G2J(item.createdAtDateTime) }}</span></td>
      <td><span>{{ item.amount.toLocaleString() }}</span></td>
      <td class="hide-768"><span>{{ item.destinationWalletAddress ? item.destinationWalletAddress : bankAccount }} </span></td>
      <td class="hide-768"><span>{{ item.id }}</span></td>
      <td><span :class="{'green':item.isDone === 'موفق' , 'red':item.isDone === 'ناموفق'}">{{ !item.isDone ?dict[item.transactionStatus] : done[item.isDone]  }}</span></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "rialTRHistory",

  data() {
    return {
      rialTrsheader: ['زمان و تاریخ', 'مقدار(تومان)', 'بانک | شماره شبا', 'شماره پیگیری', 'وضعیت'],
            dict: {"SUCCESS": "موفق", 'FAIL': "ناموفق", "WITHDRAW": 'برداشت', "DEPSOIT": 'واریز', "RAISED_BY_USER":'شارژ شده توسط کاربر' , "PENDING": 'در انتظار'},
            done:{"true":"موفقث", "false":"ناموفق"},

      //rial transaction
      transactions:[]
      
    }
  },
  methods:{
    async getTomanTransactions(){
           this.state.loading=true;  
      let withdrawals = await this.$axios.get('/wallets/withdrawal-requests?size=1000')
      let deposits = await this.$axios.get('/wallets/deposit?size=1000')
withdrawals = withdrawals.content
deposits = deposits.content
deposits = deposits.filter(el =>el.relatedCoin ==='TOMAN')
withdrawals = withdrawals.filter(el =>el.relatedCoin ==='TOMAN')
let concats = deposits.concat(withdrawals)
concats = concats.sort((a,b)=>{
a.createdAtDateTime < b.createdAtDateTime


})
this.transactions = concats


    },
  },
  mounted() {
    this.getTomanTransactions()


  }
}
</script>

<style lang="scss" scoped>

table {
  table-layout: auto;
height: 300px;
  ovrflow-y: scroll;
  th {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    background-color: #091222;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  td {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    height: 40px;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  .header-table {
    height: 65px;
    position: sticky;
    top: 0;

    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }

  .body {
    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }
}

@media (max-width: 992px) {
  .hide-992{
    display:none !important;
  }
}

@media (max-width: 768px) {
  .hide-768{
    display:none !important;
  }
}

@media (max-width: 400px) {
  .hide-400{
    display:none !important;
  }
}
</style>